import { render, staticRenderFns } from "./OrganisationsList.vue?vue&type=template&id=6afec295"
import script from "./OrganisationsList.vue?vue&type=script&lang=js"
export * from "./OrganisationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports